/**
 * LoginModal - Redirects to centralized auth or allows guest mode
 */
import React from 'react';
import { useAuth } from '../../contexts/AuthContext';
import './LoginModal.css';

const LoginModal = ({ isOpen, onClose }) => {
  const { continueAsGuest, redirectToAuth } = useAuth();

  if (!isOpen) return null;

  const handleLogin = () => {
    redirectToAuth('login');
  };

  const handleSignup = () => {
    redirectToAuth('signup');
  };

  const handleContinueAsGuest = () => {
    continueAsGuest();
    onClose();
  };

  return (
    <>
      <div className="login-modal-backdrop" onClick={onClose}></div>

      <div className="login-modal-wrapper">
        <div className="login-modal-card">
          <button
            type="button"
            className="login-modal-close"
            onClick={onClose}
            aria-label="Fermer"
          >
            <i className="bi bi-x-lg"></i>
          </button>

          <div className="login-modal-header">
            <div className="login-modal-icon">
              <i className="bi bi-box-arrow-in-right"></i>
            </div>
            <h2 className="login-modal-title">Connexion requise</h2>
            <p className="login-modal-subtitle">
              Connectez-vous pour sauvegarder vos tournois et y accéder depuis n'importe quel appareil.
            </p>
          </div>

          <div className="login-modal-actions">
            <button
              type="button"
              className="login-modal-btn-primary"
              onClick={handleLogin}
            >
              <i className="bi bi-box-arrow-in-right"></i>
              Se connecter
            </button>

            <button
              type="button"
              className="login-modal-btn-secondary"
              onClick={handleSignup}
            >
              <i className="bi bi-person-plus"></i>
              Créer un compte
            </button>
          </div>

          <div className="login-modal-divider">
            <div className="login-modal-divider-line"></div>
            <span className="login-modal-divider-text">ou</span>
            <div className="login-modal-divider-line"></div>
          </div>

          <button
            type="button"
            className="login-modal-btn-ghost"
            onClick={handleContinueAsGuest}
          >
            <i className="bi bi-person"></i>
            Continuer en mode invité
          </button>
        </div>
      </div>
    </>
  );
};

export default LoginModal;
